import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import OrdersListView from "@screens/OrdersList/View";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import t from "@constants/localization";
import { getAllOrders } from "../../services/api";

const PATH = "screens/CustomerProfile/UsersOrderList";

const UsersOrderList = (props) => {
  const [user, setUser] = useState(
    props.navigation &&
      props.route &&
      props.route.params &&
      props.route.params.user,
  );
  const [orders, setOrders] = useState([]);
  const [isFetchingOrders, setIsFetchingOrders] = useState(true);
  const [canFetchOrders, setCanFetchOrders] = useState(true);
  const { url } = useSelector((state) => state.auth.user);
  const offset = useRef(0);
  const limit = useRef(10);
  const totalOrders = useRef(0);

  useEffect(() => {
    fetchCustomerOrders(true);
  }, []);

  const fetchCustomerOrders = (firstCall = false) => {
    setCanFetchOrders(orders.length >= totalOrders.current);
    if (!firstCall && orders.length >= totalOrders.current) {
      return;
    }
    if (Array.isArray(orders) && orders.length < totalOrders.current) {
      offset.current = firstCall
        ? offset.current
        : offset.current + limit.current;
    }
    const payload = {
      offset: offset.current,
      limit: limit.current,
      url,
      userId: user ? user.user_id : "",
      date: props?.route?.params?.date ?? "",
    };
    getAllOrders(payload)
      .then(({ data }) => {
        totalOrders.current = data.count;
        setOrders(orders.concat(data.orders));
        setIsFetchingOrders(false);
      })
      .catch((e) => {
        console.log(e);
        setIsFetchingOrders(false);
      });
  };
  return (
    <>
      <HeaderWithBackAndTitle
        headertitle={
          props.route.params.headerTitle ??
          `${props.route.params.user.user_name}'s Orders`
        }
        headerColor="#fff"
        hideShadow={false}
        navigation={props.navigation}
        route={props.route}
        subHeaderTitle={props.route.params.subHeaderTitle}
      />
      <OrdersListView
        isProfileShow={true}
        waText={t(`${PATH}/shareBill`)}
        orders={orders}
        fetchCommunityLeaderOrders={fetchCustomerOrders}
        loading={isFetchingOrders}
        canFetchOrders={canFetchOrders}
        userId={user.user_id}
        eventProps={props.route.params.eventProps}
      />
    </>
  );
};

export default UsersOrderList;
